import './assets/index.css'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)
Vue.locale('CN', zhLocale)
Vue.locale('EN', enLocale)

Vue.config.lang = 'EN'
Vue.prototype.$setLang = (lang) => {
  Vue.config.lang = lang
}
Vue.prototype.$getLang = () => {
  return Vue.config.lang
}

Vue.prototype.$eventBus = new Vue()

Vue.use(require('./plugins/utils').default)

/*导入router*/
import router from './router/index'

/*导入element-ui*/
import './plugins/element'

/*注册自定义组件*/
import './components/index'

/*Vuex*/
import store from './store'

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render(h) {
    return h(require('./App.vue').default)
  },
  methods: {
    getCurrentLang() {
      var lang = this.$route.query.lang
      if (lang) {
        lang = lang.toUpperCase()
        switch (lang) {
          case 'CN':
            return 'CN'
          case 'EN':
            return 'EN'
        }
      }
      return 'EN'
    },
    autoSetCurrentLang() {
      var lang = this.getCurrentLang()
      this.$setLang(lang)
    },
    getCurrentRegion() {
      var region = this.$route.query.region
      return region && region.toUpperCase() == 'US' ? 'US' : 'GLOBAL'
    },
    convertLangArea(area, currentLang) {
      var areas = []
      if (currentLang.toUpperCase() == 'CN') {
        areas = this.$getOptions('areaCN')
      }
      if (currentLang.toUpperCase() == 'EN') {
        areas = this.$getOptions('areaEN')
      }
      for (let i = 0; i < areas.length; i++) {
        if (areas[i].value == area) return areas[i].label
      }
      return area
    }
  }
}).$mount('#app')
